<template>
    <div class="horse-pedigree">
        <p-input
            name="pedigrees[V]"
            v-model="pedigreeStructure.V"
            parent-prefix="V"
            level-parent="2"
            @newData="setNewData"
            is-stallion
            is-required
            name-label="javascript.horse_registration.father_name"
            :label="'javascript.horse_registration.father_information' | trans"
        ></p-input>
        <p-input
            name="pedigrees[M]"
            v-model="pedigreeStructure.M"
            parent-prefix="M"
            level-parent="2"
            @newData="setNewData"
            is-required
            name-label="javascript.horse_registration.mother_name"
            :label="'javascript.horse_registration.mother_information' | trans"
        ></p-input>
        <p-input
            name="pedigrees[M][parent][V]"
            v-model="pedigreeStructure.MV"
            parent-prefix="MV"
            level-parent="3"
            @newData="setNewData"
            is-stallion
            is-required
            name-label="javascript.horse_registration.mother_father_name"
            :label="'javascript.horse_registration.mother_father_information' | trans"
        ></p-input>
    </div>
</template>
<script>
import { PedigreeData } from '../../mixins/PedigreeData'

import Input from './ParentInput'
import { EventBus } from './event-bus'
export default {
    props: {
        pedigrees: {
            type: Object | Array,
            default() {
                return null
            },
        },
        horseId: {
            type: Number,
            required: false,
        },
    },

    data() {
        return {
            show: false,
            pedigreeStructure: {
                V: {
                    name: null,
                    life_id: null,
                    is_loaded: null,
                },
                VV: {
                    name: null,
                    life_id: null,
                    is_loaded: null,
                },

                VM: {
                    name: null,
                    life_id: null,
                    is_loaded: null,
                },

                M: {
                    name: null,
                    life_id: null,
                    is_loaded: null,
                },
                MV: {
                    name: null,
                    life_id: null,
                    is_loaded: null,
                },

                MM: {
                    name: null,
                    life_id: null,
                    is_loaded: null,
                },
            },
        }
    },

    mixins: [PedigreeData],

    provide() {
        return {
            isParentDataLoaded: this.isParentDataLoaded,
            getParentRef: this.getParentRef,
            horseId: this.horseId,
        }
    },

    components: {
        'p-input': Input,
    },

    mounted() {
        // merge pedigree from server with the local pedigree
        if (this.pedigrees) {
            this.pedigreeStructure = this.merge(this.pedigreeStructure, this.pedigrees)
            EventBus.$emit(`is-initialized-${this.horseId || 0}`)
        }
        this.show = true
        const formControlInputs = document.querySelectorAll('.twitter-typeahead .form-control:not(.tt-hint)');

        formControlInputs.forEach(input => {
          input.addEventListener('focus', () => {
            const label = input.parentElement.parentElement.querySelector('label.form-control-placeholder');
            if (label) {
              label.classList.add('focused');
            }
          });

          input.addEventListener('blur', () => {
            const label = input.parentElement.parentElement.querySelector('label.form-control-placeholder');
            if (!input.value && label) {
              label.classList.remove('focused');
            }
          });
        });
    },
    methods: {
        setNewData(data) {
            if (data) {
                this.pedigreeStructure = this.merge(this.pedigreeStructure, data)
                EventBus.$emit(`is-loaded-${this.horseId || 0}`)
            }
        },
        isParentDataLoaded(parentPrefix) {
            if (
                this.pedigreeStructure[parentPrefix] &&
                !!this.pedigreeStructure[parentPrefix].is_loaded
            ) {
                return true
            }
            if (['V', 'M'].includes(parentPrefix)) {
                return false
            }

            return this.isParentDataLoaded(parentPrefix.substring(0, parentPrefix.length - 1))
        },
        getParentRef(prefix) {
            return this.horseId ? `${prefix}_${this.horseId}` : prefix
        },
        merge(target, source) {
            // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
            for (let key of Object.keys(source)) {
                if (source[key] instanceof Object && key in target)
                    Object.assign(source[key], this.merge(target[key], source[key]))
            }

            // Join `target` and modified `source`
            Object.assign(target || {}, source)
            return target
        },
    },
}
</script>
<style lang="scss">
.horse-pedigree {
  fieldset.form-group span.twitter-typeahead {
    display: block !important;
}
label.form-control-placeholder.focused, label.form-control-placeholder.loaded
 {
    font-size: 0.875rem;
    -webkit-transform: translate3d(0, -47%, 0);
    transform: translate3d(0, -47%, 0);
    opacity: 0.8;
    padding-left: 0;
    left: 12px;
    color: #555;
}

.typeahead-menu {
    padding: 0;
    margin: 0;
    border: none;
    background: #ffffff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    width: calc(300% + 2px);
}

.typeahead-menu .list-item {
    padding: 8px 16px;
    cursor: pointer;
}

.typeahead-menu .list-item:hover {
    background-color: #f1f1f1;
}

form fieldset .form-control.name-input {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
}


.typeahead-menu .empty-message {
    padding: 8px 12px;
}

.typeahead-menu {
    width: 100%!important;
}

span.twitter-typeahead {
    width: 100%;
}

.tt-suggestion strong {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

}

.V_lifeIDPrefixSelect,
.M_lifeIDPrefixSelect,
.MV_lifeIDPrefixSelect {
  position: relative; /* Ensure the z-index property works */
}

.V_lifeIDPrefixSelect {
  z-index: 3000 !important;
}

.M_lifeIDPrefixSelect {
  z-index: 2000 !important;
}

.MV_lifeIDPrefixSelect {
  z-index: 1000 !important;
}

</style>
